// extracted by mini-css-extract-plugin
export var md = "_5y-4";
export var semantic = "_5y-5";
export var sm = "_5y-3";
export var text = "_5y-6";
export var toggleInput = "_5y-0";
export var toggleSwitch = "_5y-1";
export var xs = "_5y-2";